import React from 'react';
import blurLoading from "../assets/images/blurLoading.png";

export default function SuspenseFallback() {
  return (
    <div className="bg-[url('assets/images/bgLoading.jpg')] bg-cover bg-fixed bg-center h-screen relative w-full overflow-hidden flex items-center justify-center">
      {/* Centered spinner for dynamic loading overlay */}
      <div className="relative z-40 flex flex-col items-center">
        <div className="w-16 h-16 border-[6px] border-[#FBE67B] border-dotted rounded-full animate-spin border-t-transparent"></div>
        <div className="mt-4 text-[#FBE67B] font-semibold text-lg tracking-wider animate-pulse">Loading...</div>
      </div>
      
      {/* Decorative blurred image at the bottom left, mimicking Loading.jsx */}
      <img
        src={blurLoading}
        alt="blurLoading"
        className="absolute bottom-0 left-0 pointer-events-none"
      />
    </div>
  );
}
